export default __webpack_public_path__ + "static/media/Snapchat.e07c311c.png";